import {Component, Inject, inject} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ApiBaseService} from "../../../../../../projects/vendors/src/lib/services/api-base.service";
import {FormHelper, KeyValue} from '../../../../../../projects/vendors/src/lib/services/form-helper';
import {CartResponseDetail} from "../../../../@domain/on-going-order";
import {ApiEnum} from "../../../../@application/enum/api.enum";
import {forkJoin} from "rxjs";


@Component({
    selector: 'lib-update-food-status-dialog',
    templateUrl: './update-food-status-dialog.component.html',
    styleUrl: './update-food-status-dialog.component.css',
    standalone: false
})
export class UpdateFoodStatusDialogComponent {

  foodStatusForm!: FormGroup;
  apiBaseService = inject(ApiBaseService)
  statusKeyValue = [] as KeyValue []

  constructor(@Inject(MAT_DIALOG_DATA) public data: {
                itemName: string,
                foodItem: CartResponseDetail,
                orderId: string,
                tableName: string,
                // Set to update every item of an order in one action.
                cartIds?: string[],
              },
              private dialogRef: MatDialogRef<UpdateFoodStatusDialogComponent>) {
    this.statusKeyValue = FormHelper.GetCartStatusList()
  }

  ngOnInit(): void {
    this.formInit();
  }


  private formInit() {
    this.foodStatusForm = new FormGroup({
      orderId: new FormControl(this.data?.orderId, [Validators.required]),
      status: new FormControl(this.data?.foodItem?.cartStatus, [Validators.required]),
      itemName: new FormControl(this.data?.itemName, [Validators.required]),
      tableName: new FormControl(this.data?.tableName),
    })
  }

  onSubmit() {
    if (this.foodStatusForm.valid) {
      const data: any = this.foodStatusForm.value;
      this.updateFoodStatus(data)
    } else {
      Object.values(this.foodStatusForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({onlySelf: true})
        }
      })
    }
  }

  private updateFoodStatus(data: any) {
    const cartIds = this.data.cartIds ?? [this.data.foodItem.id];
    forkJoin(cartIds.map(id =>
      this.apiBaseService.PATCH_API<any>([ApiEnum.RestaurantModule, ApiEnum.Cart, ApiEnum.CartStatus, id], data)))
      .subscribe({
        next: value => {
          this.dialogRef.close(value);
        }
      })
  }

}
